import React, { useEffect } from "react";
import Booksdetailscard from "../../components/Reuseablecomponents/Booksdetailscard/Booksdetailscard";
import OwlCarousel from 'react-owl-carousel';
import "./Homepage.css";
import { Booksdatalist } from "../../Booksdatalist/Booksdatalist";
import Flashdealtimer from "../../components/Reuseablecomponents/Flashdealtimer/Flashdealtimer";
import { Link } from "react-router-dom";

export default function Homepage() {

    useEffect(() => {
        window.scrollTo(0, 0);

    }, [])

    const options1 = {
        loop: false,
        margin: 24,
        dots: false,
        mouseDrag: true,
        merge: true,
        autoplay: false,
        navText: ["<i class='fa fa-angle-left'></i>", "<i class='fa fa-angle-right'></i>"],
        autoplayHoverPause: false,
        responsive: {
            0: {
                nav: false
            },
            900: {
                items: 3.85,
                nav: true,
            },
            1200: {
                items: 4.89,
                nav: true,
            },
            1400: {
                items: 5.89,
                nav: true,
            }
        }
    };

    const date = new Date('12/15/2022')

    return (
        <>

            {/* Home page start */}

            <section className="booksmart_homepage_container">

                <div className="d-flex justify-content-between booksmart_homepage_banner">
                    <div className="booksmart_homepage_left_banner">
                        <div className="booksmart_homepage_left_banner_img_grid">
                            <div className="booksmart_homepage_left_banner_img_grid_layout">
                                <img src="/assets/images/image-grid.png" alt="img-grid" />
                            </div>
                        </div>
                        <div className="booksmart_homepage_left_banner_content">
                            <h3>
                                World Book Day
                            </h3>
                            <p>25 - 30 Nov 2022</p>
                        </div>
                    </div>
                    <div className="booksmart_homepage_right_banner">
                        <div className="booksmart_homepage_right_banner_card card_brown">
                            <div className="booksmart_homepage_right_banner_img_grid">
                                <div className="booksmart_homepage_right_banner_img_grid_layout">
                                    <img src="/assets/images/image-grid.png" alt="img-grid" />
                                </div>
                            </div>
                            <div className="booksmart_homepage_right_banner_content">
                                <h3>
                                    Get The New Books Every Month
                                </h3>
                                <p>Lorem ipsum dolor sit amet, consectetur adipiscing </p>
                            </div>
                        </div>

                        <div className="booksmart_homepage_right_banner_card card_blue">
                            <div className="booksmart_homepage_right_banner_img_grid">
                                <div className="booksmart_homepage_right_banner_img_grid_layout">
                                    <img src="/assets/images/image-grid.png" alt="img-grid" />
                                </div>
                            </div>
                            <div className="booksmart_homepage_right_banner_content">
                                <h3>
                                    Get The New Books Every Month
                                </h3>
                                <p>Lorem ipsum dolor sit amet, consectetur adipiscing </p>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="booksmart_homepage_slider">
                    <div className="d-flex gap-2">
                        <div className="booksmart_homepage_slider_heading">
                            Flash Deal
                        </div>
                        <div>
                            <p className="booksmart_homepage_slider_timer">
                                <Flashdealtimer eventDate={date} />
                            </p>
                        </div>
                    </div>

                    <div className="booksmart_homepage_slider_carousel">

                        <OwlCarousel className="owl-theme" {...options1}>

                            {Booksdatalist.map((book, index) => <Booksdetailscard key={index} book={book} />)}
                            {Booksdatalist.map((book, index) => <Booksdetailscard key={index} book={book} />)}

                        </OwlCarousel>
                    </div>
                </div>

                <div className="booksmart_homepage_category">
                    <div className="booksmart_homepage_category_header">
                        Best Sellers
                    </div>
                    <nav className="booksmart_homepage_category_nav">
                        <div className="nav nav-tabs" id="nav-tab" role="tablist">
                            <button className="nav-link" id="nav-home-tab" data-bs-toggle="tab" data-bs-target="#nav-home" type="button" role="tab" aria-controls="nav-home" aria-selected="true">
                                University
                            </button>
                            <button className="nav-link" id="nav-profile-tab" data-bs-toggle="tab" data-bs-target="#nav-profile" type="button" role="tab" aria-controls="nav-profile" aria-selected="false">
                                Under 17+
                            </button>
                            <button className="nav-link" id="nav-contact-tab" data-bs-toggle="tab" data-bs-target="#nav-contact" type="button" role="tab" aria-controls="nav-contact" aria-selected="false">
                                Financial Planner
                            </button>
                            <button className="nav-link active" id="nav-contact-tab" data-bs-toggle="tab" data-bs-target="#nav-contact" type="button" role="tab" aria-controls="nav-contact" aria-selected="false">
                                Money Management
                            </button>
                            <button className="nav-link" id="nav-contact-tab" data-bs-toggle="tab" data-bs-target="#nav-contact" type="button" role="tab" aria-controls="nav-contact" aria-selected="false">
                                For Women
                            </button>
                            <button className="nav-link" id="nav-contact-tab" data-bs-toggle="tab" data-bs-target="#nav-contact" type="button" role="tab" aria-controls="nav-contact" aria-selected="false">
                                Entrepreneurship
                            </button>
                            <button className="nav-link" id="nav-contact-tab" data-bs-toggle="tab" data-bs-target="#nav-contact" type="button" role="tab" aria-controls="nav-contact" aria-selected="false">
                                Motivation & Quotes
                            </button>
                        </div>
                    </nav>

                    <div className="booksmart_homepage_category_cards">
                        {Booksdatalist.map((book, index) => <div className="booksmart_homepage_category_card" key={index}>
                            <Booksdetailscard book={book} />
                        </div>)}
                    </div>
                </div>

                <div className="booksmart_homepage_category">
                    <div className="booksmart_homepage_category_header">
                        Trending on TikTok - #Booktok
                    </div>
                    <nav className="booksmart_homepage_category_nav">
                        <div className="nav nav-tabs" id="nav-tab" role="tablist">
                            <button className="nav-link" id="nav-home-tab" data-bs-toggle="tab" data-bs-target="#nav-home" type="button" role="tab" aria-controls="nav-home" aria-selected="true">
                                University
                            </button>
                            <button className="nav-link" id="nav-profile-tab" data-bs-toggle="tab" data-bs-target="#nav-profile" type="button" role="tab" aria-controls="nav-profile" aria-selected="false">
                                Under 17+
                            </button>
                            <button className="nav-link" id="nav-contact-tab" data-bs-toggle="tab" data-bs-target="#nav-contact" type="button" role="tab" aria-controls="nav-contact" aria-selected="false">
                                Financial Planner
                            </button>
                            <button className="nav-link" id="nav-contact-tab" data-bs-toggle="tab" data-bs-target="#nav-contact" type="button" role="tab" aria-controls="nav-contact" aria-selected="false">
                                Money Management
                            </button>
                            <button className="nav-link" id="nav-contact-tab" data-bs-toggle="tab" data-bs-target="#nav-contact" type="button" role="tab" aria-controls="nav-contact" aria-selected="false">
                                For Women
                            </button>
                            <button className="nav-link active" id="nav-contact-tab" data-bs-toggle="tab" data-bs-target="#nav-contact" type="button" role="tab" aria-controls="nav-contact" aria-selected="false">
                                Entrepreneurship
                            </button>
                            <button className="nav-link" id="nav-contact-tab" data-bs-toggle="tab" data-bs-target="#nav-contact" type="button" role="tab" aria-controls="nav-contact" aria-selected="false">
                                Motivation & Quotes
                            </button>
                        </div>
                    </nav>

                    <div className="booksmart_homepage_category_cards">
                        {Booksdatalist.map((book, index) => <div className="booksmart_homepage_category_card" key={index}>
                            <Booksdetailscard book={book} />
                        </div>)}
                    </div>
                </div>

                <div className="booksmart_homepage_special_price">

                    <div className="d-flex align-items-center">
                        <div className="booksmart_homepage_special_price_img-grid">
                            <div className="booksmart_homepage_special_price_img_layout">
                                <img src="/assets/images/image-grid-big.png" alt="img-grid" />
                            </div>
                        </div>
                        <div className="booksmart_homepage_special_price_details">
                            <h3>GET SPECIAL PRICE</h3>
                            <p>
                                If you are a merchant and want to
                                buy books in large quantities
                            </p>
                            <div className="booksmart_homepage_special_price_details_button">
                                Sign Up Now
                            </div>
                        </div>
                    </div>

                </div>

                <div className="booksmart_homepage_category">
                    <div className="booksmart_homepage_category_header">
                        Recommended - Business Leader
                    </div>
                    <nav className="booksmart_homepage_category_nav">
                        <div className="nav nav-tabs" id="nav-tab" role="tablist">
                            <button className="nav-link" id="nav-home-tab" data-bs-toggle="tab" data-bs-target="#nav-home" type="button" role="tab" aria-controls="nav-home" aria-selected="true">
                                University
                            </button>
                            <button className="nav-link" id="nav-profile-tab" data-bs-toggle="tab" data-bs-target="#nav-profile" type="button" role="tab" aria-controls="nav-profile" aria-selected="false">
                                Under 17+
                            </button>
                            <button className="nav-link active" id="nav-contact-tab" data-bs-toggle="tab" data-bs-target="#nav-contact" type="button" role="tab" aria-controls="nav-contact" aria-selected="false">
                                Financial Planner
                            </button>
                            <button className="nav-link" id="nav-contact-tab" data-bs-toggle="tab" data-bs-target="#nav-contact" type="button" role="tab" aria-controls="nav-contact" aria-selected="false">
                                Money Management
                            </button>
                            <button className="nav-link" id="nav-contact-tab" data-bs-toggle="tab" data-bs-target="#nav-contact" type="button" role="tab" aria-controls="nav-contact" aria-selected="false">
                                For Women
                            </button>
                            <button className="nav-link" id="nav-contact-tab" data-bs-toggle="tab" data-bs-target="#nav-contact" type="button" role="tab" aria-controls="nav-contact" aria-selected="false">
                                Entrepreneurship
                            </button>
                            <button className="nav-link" id="nav-contact-tab" data-bs-toggle="tab" data-bs-target="#nav-contact" type="button" role="tab" aria-controls="nav-contact" aria-selected="false">
                                Motivation & Quotes
                            </button>
                        </div>
                    </nav>

                    <div className="booksmart_homepage_category_cards">
                        {Booksdatalist.map((book, index) => <div className="booksmart_homepage_category_card" key={index}>
                            <Booksdetailscard book={book} />
                        </div>)}
                    </div>
                </div>

                <div className="booksmart_homepage_category">
                    <div className="booksmart_homepage_category_header">
                        New Arrivals
                    </div>
                    <nav className="booksmart_homepage_category_nav">
                        <div className="nav nav-tabs" id="nav-tab" role="tablist">
                            <button className="nav-link active" id="nav-home-tab" data-bs-toggle="tab" data-bs-target="#nav-home" type="button" role="tab" aria-controls="nav-home" aria-selected="true">
                                University
                            </button>
                            <button className="nav-link" id="nav-profile-tab" data-bs-toggle="tab" data-bs-target="#nav-profile" type="button" role="tab" aria-controls="nav-profile" aria-selected="false">
                                Under 17+
                            </button>
                            <button className="nav-link" id="nav-contact-tab" data-bs-toggle="tab" data-bs-target="#nav-contact" type="button" role="tab" aria-controls="nav-contact" aria-selected="false">
                                Financial Planner
                            </button>
                            <button className="nav-link" id="nav-contact-tab" data-bs-toggle="tab" data-bs-target="#nav-contact" type="button" role="tab" aria-controls="nav-contact" aria-selected="false">
                                Money Management
                            </button>
                            <button className="nav-link" id="nav-contact-tab" data-bs-toggle="tab" data-bs-target="#nav-contact" type="button" role="tab" aria-controls="nav-contact" aria-selected="false">
                                For Women
                            </button>
                            <button className="nav-link" id="nav-contact-tab" data-bs-toggle="tab" data-bs-target="#nav-contact" type="button" role="tab" aria-controls="nav-contact" aria-selected="false">
                                Entrepreneurship
                            </button>
                            <button className="nav-link" id="nav-contact-tab" data-bs-toggle="tab" data-bs-target="#nav-contact" type="button" role="tab" aria-controls="nav-contact" aria-selected="false">
                                Motivation & Quotes
                            </button>
                        </div>
                    </nav>

                    <div className="booksmart_homepage_category_newarrivals">
                        <div className="booksmart_homepage_category_newarrivals_banner">
                            <div className="booksmart_homepage_category_newarrivals_banner_details">
                                <h3>
                                    <span>2,000</span> <br /> New Books
                                </h3>
                                <p>
                                    We always get 2,000 new book titles every month
                                </p>
                            </div>
                            <div className="booksmart_homepage_category_newarrivals_banner_img_grid">
                                <img src="/assets/images/three-image-grid.png" alt="three-img-grid" />
                            </div>
                        </div>

                        <div className="booksmart_homepage_category_newarrivals_cards">
                            <div className="booksmart_homepage_category_cards">
                                {Booksdatalist.map((book, index) => <>
                                    {index < 4 &&
                                        <div className="booksmart_homepage_category_card" key={index}>
                                            <Booksdetailscard book={book} />
                                        </div>}
                                </>)}
                            </div>
                            <div className="booksmart_homepage_category_cards">
                                {Booksdatalist.map((book, index) => <>
                                    {index > 1 &&
                                        <div className="booksmart_homepage_category_card" key={index}>
                                            <Booksdetailscard book={book} />
                                        </div>}
                                </>)}
                            </div>
                        </div>
                    </div>

                </div>

                <div className="booksmart_homepage_category">
                    <div className="booksmart_homepage_category_header">
                        Popular Categories
                    </div>
                    <nav className="booksmart_homepage_category_nav">
                        <div className="nav nav-tabs" id="nav-tab" role="tablist">
                            <button className="nav-link" id="nav-home-tab" data-bs-toggle="tab" data-bs-target="#nav-home" type="button" role="tab" aria-controls="nav-home" aria-selected="true">
                                University
                            </button>
                            <button className="nav-link" id="nav-profile-tab" data-bs-toggle="tab" data-bs-target="#nav-profile" type="button" role="tab" aria-controls="nav-profile" aria-selected="false">
                                Under 17+
                            </button>
                            <button className="nav-link" id="nav-contact-tab" data-bs-toggle="tab" data-bs-target="#nav-contact" type="button" role="tab" aria-controls="nav-contact" aria-selected="false">
                                Financial Planner
                            </button>
                            <button className="nav-link" id="nav-contact-tab" data-bs-toggle="tab" data-bs-target="#nav-contact" type="button" role="tab" aria-controls="nav-contact" aria-selected="false">
                                Money Management
                            </button>
                            <button className="nav-link" id="nav-contact-tab" data-bs-toggle="tab" data-bs-target="#nav-contact" type="button" role="tab" aria-controls="nav-contact" aria-selected="false">
                                For Women
                            </button>
                            <button className="nav-link" id="nav-contact-tab" data-bs-toggle="tab" data-bs-target="#nav-contact" type="button" role="tab" aria-controls="nav-contact" aria-selected="false">
                                Entrepreneurship
                            </button>
                            <button className="nav-link active" id="nav-contact-tab" data-bs-toggle="tab" data-bs-target="#nav-contact" type="button" role="tab" aria-controls="nav-contact" aria-selected="false">
                                Motivation & Quotes
                            </button>
                        </div>
                    </nav>

                    <div className="booksmart_homepage_category_cards">
                        {Booksdatalist.map((book, index) => <div className="booksmart_homepage_category_card" key={index}>
                            <Booksdetailscard book={book} />
                        </div>)}
                    </div>
                </div>

                <div className="booksmart_homepage_bottom_banner">

                    <div className="booksmart_homepage_bottom_left_banner">
                        <div className="d-flex">
                            <div className="booksmart_homepage_bottom_left_banner_img_grid">
                                <div className="booksmart_homepage_right_banner_img_grid_layout">
                                    <img src="/assets/images/image-grid.png" alt="img-grid" />
                                </div>
                            </div>
                            <div className="booksmart_homepage_bottom_left_banner_content">
                                <h3>
                                    Buy 2 Get 3
                                </h3>
                                <p>
                                    25 - 30 Nov 2022
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="booksmart_homepage_bottom_right_banner">
                        <div className="d-flex">
                            <div className="booksmart_homepage_bottom_right_banner_img_grid">
                                <div className="booksmart_homepage_right_banner_img_grid_layout">
                                    <img src="/assets/images/image-grid.png" alt="img-grid" />
                                </div>
                            </div>
                            <div className="booksmart_homepage_bottom_right_banner_content">
                                <h3>
                                    Special Books
                                </h3>
                                <p>
                                    Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                                </p>
                            </div>
                        </div>
                    </div>

                </div>

                <div className="booksmart_homepage_sign_up_container">
                    <div className="booksmart_homepage_sign_up_container_form">
                        <div className="booksmart_homepage_sign_up_container_form_header">
                            Get 20% Off When You Subscribe to Our Newsletter
                        </div>
                        <div className="booksmart_homepage_sign_up_container_form_text">
                            Receive exclusive offers and resources
                        </div>
                        <form>
                            <input type="email" className="form-control" id="email" placeholder="Enter email" name="email" />
                            <button type="button" className="booksmart_homepage_sign_up_container_form_button">
                                <Link to="/loginpage">Sign Up Now</Link>
                            </button>
                        </form>
                    </div>
                </div>

            </section>

            {/* Home page over */}

        </>
    )

}